// extracted by mini-css-extract-plugin
module.exports = {"streamSpecs":"specs_streamSpecs__p1_pd"};